import { h } from 'preact';
import { getLanguage, SUPPORTED_LANGUAGES } from '../utils/i18n.jsx';
import './LanguageSwitcher.css';

const languageNames = {
  'en': 'English',
  'ar': 'Arabic',
  'fr': 'French',
  'hi': 'Hindi',
  'id': 'Indonesian',
  'ja': 'Japanese',
  'ko': 'Korean',
  'ms': 'Malay',
  'pt': 'Portuguese (Brazilian)',
  'es': 'Spanish',
  'th': 'Thai',
  'vi': 'Vietnamese'
};

export function LanguageSwitcher() {
  const currentLang = getLanguage();

  const handleLanguageChange = (e) => {
    const newLang = e.target.value;
    const url = new URL(window.location);
    url.searchParams.set('hl', newLang);
    window.location.href = url.toString();
  };

  return (
    <div class="language-switcher">
      <select onChange={handleLanguageChange} value={currentLang}>
        {SUPPORTED_LANGUAGES.map(code => (
          <option key={code} value={code}>{languageNames[code] || code}</option>
        ))}
      </select>
    </div>
  );
}